module.exports = __webpack_public_path__ + "static/media/sony-alpha-5.d2861664.jpg";